import React from 'react';
import About from '../screens/About';
import Contact from '../screens/Contact';
import HeroSection from '../screens/HeroSection';
import Experience from '../screens/Experience';
import Skills from '../screens/Skills';
import Works from '../screens/Works';
import Achievements from '../screens/Achievements';
import Footer from './Footer';

const Main = ({ closeNav, language }) => {
  const handleMainClick = (e) => {
    if (e.target === e.currentTarget) {
      closeNav();
    }
  };

  return(
    <div onClick={handleMainClick} className='main'>
        <HeroSection language={language} />
        <About language={language} />
        <Skills language={language} />
        <Experience language={language} />
        <Works language={language} />
        <Achievements language={language} />
        <Contact language={language} />
        <Footer />
    </div>
  )
};

export default Main; 